<!-- Compact Card Design -->
<div *ngIf="isCompact && !isActivityList" class="compact-card">
  <!-- Collections Warning Banner -->
  <div *ngIf="dashboardItem?.isInCollections" class="compact-past-due-banner">
    <div class="compact-past-due-message">Your Account is in Collections</div>
  </div>

  <!-- Past Due Warning Banner -->
  <div
    *ngIf="dashboardItem?.isPastDue && !dashboardItem?.isInCollections"
    class="compact-past-due-banner"
  >
    <div class="compact-past-due-message">
      {{ dashboardItem?.pastDueMessage }}
    </div>
  </div>

  <div
    class="compact-card-title-container"
    *ngIf="!dashboardItem?.isPastDue && !dashboardItem?.isInCollections"
  >
    <h4 class="compact-card-title">
      {{ dashboardItem?.title }}
    </h4>
    <span
      *ngIf="
        (dashboardItem?.code === 'architectural-application' ||
          dashboardItem?.code === 'compliance') &&
        dashboardItem?.value
      "
      class="compact-badge"
    >
      {{ dashboardItem?.value }}
    </span>
  </div>

  <!-- Account Balance Card -->
  <ng-container *ngIf="dashboardItem?.code === 'account-statement'">
    <div class="compact-balance-container">
      <div
        class="compact-balance-icon"
        *ngIf="!dashboardItem?.isPastDue && !dashboardItem?.isInCollections"
      >
        <img src="assets/icons/money.svg" alt="Balance" />
      </div>
      <div
        class="compact-balance-icon-warning"
        *ngIf="dashboardItem?.isPastDue || dashboardItem?.isInCollections"
      >
        <i class="fas fa-exclamation-triangle"></i>
      </div>
      <span
        class="compact-balance-amount"
        [ngClass]="{
          'compact-balance-amount-past-due':
            dashboardItem?.isPastDue || dashboardItem?.isInCollections
        }"
      >
        {{ dashboardItem?.value }}
      </span>
    </div>

    <!-- Collections Info -->
    <ng-container *ngIf="dashboardItem?.isInCollections">
      <p class="compact-collections-message">
        {{ dashboardItem?.collectionsMessage }}
      </p>
      <p
        class="compact-collections-contact"
        *ngIf="dashboardItem?.collectionsContactInfo"
      >
        Please contact Attorney at
        <a
          class="compact-collections-phone"
          [href]="'tel:' + dashboardItem?.collectionsContactInfo"
        >
          {{ dashboardItem?.collectionsContactInfo }}
        </a>
        .
      </p>
    </ng-container>

    <!-- Normal account actions (not in collections) -->
    <ng-container *ngIf="!dashboardItem?.isInCollections">
      <button class="compact-payment-btn" id="/accounts/one-time-payment">
        Make One-Time Payment
      </button>
      <a class="compact-link" id="view-account-statement">
        View My Account Statement
      </a>
    </ng-container>
  </ng-container>

  <!-- Compliance/Violations Card -->
  <ng-container *ngIf="dashboardItem?.code === 'compliance'">
    <div
      *ngIf="dashboardItem?.violations?.length > 0"
      class="compact-violations-table"
    >
      <div class="compact-violations-table-header">
        <span class="compact-violations-col-category">Category</span>
        <span class="compact-violations-col-date">Date</span>
        <span class="compact-violations-col-status">Status</span>
        <span class="compact-violations-col-notice">Notice</span>
      </div>
      <div
        *ngFor="
          let violation of dashboardItem?.violations;
          trackBy: trackByIndex
        "
        class="compact-violations-table-row"
      >
        <span
          class="compact-violations-col-category"
          [title]="violation.category"
        >
          {{ violation.category }}
        </span>
        <span class="compact-violations-col-date">
          {{ violation.date | date: 'MM/dd/yyyy' }}
        </span>
        <span class="compact-violations-col-status">
          {{ violation.status }}
        </span>
        <span class="compact-violations-col-notice">
          <a
            *ngIf="violation.noticeUrl"
            class="compact-violations-notice-link"
            (click)="
              onViewNoticeClick(violation.noticeFileName, violation.noticeUrl)
            "
          >
            View Notice
          </a>
          <span *ngIf="!violation.noticeUrl">-</span>
        </span>
      </div>
    </div>

    <div *ngIf="dashboardItem?.compactIsOk" class="compact-status-row">
      <i
        class="fas compact-status-icon fa-check-circle compact-icon-success"
      ></i>
      <span class="compact-status-text">
        {{ dashboardItem?.compactMessage }}
      </span>
    </div>
    <a class="compact-link" [id]="dashboardItem?.compactLinkId">
      {{ dashboardItem?.compactLinkText }}
    </a>
  </ng-container>

  <!-- Architectural Requests Card -->
  <ng-container *ngIf="dashboardItem?.code === 'architectural-application'">
    <div
      *ngIf="dashboardItem?.architecturalRequests?.length > 0"
      class="compact-architectural-table"
    >
      <div class="compact-architectural-table-header">
        <span class="compact-architectural-col-category">Category</span>
        <span class="compact-architectural-col-requested">Received</span>
        <span class="compact-architectural-col-status">Status</span>
      </div>
      <div
        *ngFor="
          let request of dashboardItem?.architecturalRequests;
          trackBy: trackByIndex
        "
        class="compact-architectural-table-row"
      >
        <span
          class="compact-architectural-col-category"
          [title]="request.category"
        >
          {{ request.category }}
        </span>
        <span class="compact-architectural-col-requested">
          {{ request.requestedDate | date: 'MM/dd/yyyy' }}
        </span>
        <span class="compact-architectural-col-status">
          {{ request.status }}
        </span>
      </div>
    </div>
    <a class="compact-link" [id]="dashboardItem?.compactLinkId">
      {{ dashboardItem?.compactLinkText }}
    </a>
  </ng-container>

  <!-- Documents Card -->
  <ng-container *ngIf="dashboardItem?.code === 'my-doc'">
    <div
      *ngIf="dashboardItem?.documents?.length > 0"
      class="compact-documents-table"
    >
      <div class="compact-documents-table-header">
        <span class="compact-documents-col-type">Type</span>
        <span class="compact-documents-col-date">Effective Date</span>
        <span class="compact-documents-col-file">File</span>
      </div>
      <div
        *ngFor="let doc of dashboardItem?.documents; trackBy: trackByIndex"
        class="compact-documents-table-row"
      >
        <span class="compact-documents-col-type" [title]="doc.type">
          {{ doc.type }}
        </span>
        <span class="compact-documents-col-date">
          {{ doc.effectiveDate | date: 'MM/dd/yyyy' }}
        </span>
        <span class="compact-documents-col-file" [title]="doc.fileName">
          <a
            *ngIf="doc.fileUrl"
            class="compact-documents-file-link"
            (click)="onViewDocumentClick(doc.fileName, doc.fileUrl)"
          >
            {{ doc.fileName }}
          </a>
          <span *ngIf="!doc.fileUrl">-</span>
        </span>
      </div>
    </div>

    <div *ngIf="dashboardItem?.compactMessage" class="compact-status-row">
      <span class="compact-status-text">
        {{ dashboardItem?.compactMessage }}
      </span>
    </div>
    <a class="compact-link" [id]="dashboardItem?.compactLinkId">
      {{ dashboardItem?.compactLinkText }}
    </a>
  </ng-container>

  <!-- Quick Links Card -->
  <ng-container *ngIf="isQuickLinks">
    <div
      class="compact-quick-links"
      [innerHTML]="dashboardItem?.html | ccSafeHtml"
    ></div>
  </ng-container>
</div>

<!-- Compact Activity Card Design -->
<div *ngIf="isActivityList" class="compact-card compact-activity-card">
  <h4 class="compact-card-title">{{ dashboardItem?.title }}</h4>
  <div class="compact-activities-container">
    <div
      *ngFor="
        let rec of dashboardItem?.activities;
        let idx = index;
        trackBy: trackByKey
      "
    >
      <div
        *ngIf="!!rec.key && rec.key.indexOf('Last user activity') !== -1"
        class="compact-last-activity"
      >
        {{ rec.key }}
      </div>
      <ng-container
        *ngIf="!!rec.key && rec.key.indexOf('Last user activity') === -1"
      >
        <div
          class="compact-activity-link"
          *ngFor="let item of rec.items; trackBy: trackByIndex"
        >
          <a
            class="compact-link"
            (click)="navigateFromActivity(item.code, item)"
            [title]="item.description"
          >
            {{ item.description }}
          </a>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<!-- Original Card Design (for non-compact, non-activity) -->
<div
  *ngIf="!isCompact && !isActivityList"
  class="user-dashboard-item-container"
  [ngClass]="{
    'user-dashboard-item-container-lg': !isSmallScreen && !isMediumScreen,
    'user-dashboard-item-container-md': isMediumScreen
  }"
>
  <dx-box
    width="100%"
    height="100%"
    align="center"
    class="tile-container cc-white-background cc-shadow-box"
  >
    <dxi-item [ratio]="1">
      <dx-box
        class="large-tile-container"
        width="100%"
        direction="col"
        [ngClass]="{
          'clickable-box': !!elementId
        }"
      >
        <dxi-item baseSize="auto">
          <div class="cc-header-strip"></div>
        </dxi-item>
        <dxi-item baseSize="auto">
          <h3 class="header-text">{{ dashboardItem?.title }}</h3>
        </dxi-item>
        <dxi-item [ratio]="1">
          <div
            class="tile-body"
            [ngClass]="{ 'quick-links-items': isQuickLinks }"
          >
            <div class="message-container" (click)="togglePopoverVisibility()">
              <div class="icon-container">
                <div
                  *ngIf="dashboardItem?.hasIcon"
                  class="dashboard-icon dx-theme-accent-as-background-color"
                  [ngClass]="{
                    'dashboard-icon-item-check': dashboardItem?.isOk
                  }"
                >
                  <i
                    [id]="'icon-' + elementId"
                    class="fas"
                    [ngClass]="{
                      'fa-check cc-lightgreen-icon': dashboardItem?.isOk,
                      'fa-info cc-white-icon': dashboardItem?.isInfo,
                      'fa-exclamation': dashboardItem?.isWarning,
                      'fa-exclamation-triangle': dashboardItem?.isHighAlert,
                      'cc-yellow-icon':
                        dashboardItem?.isWarning || dashboardItem?.isHighAlert
                    }"
                  ></i>
                </div>
              </div>
              <h4
                *ngIf="!!dashboardItem?.value"
                class="cc-value-text cc-text-center"
              >
                {{ dashboardItem?.value }}
              </h4>
              <div *ngIf="!!dashboardItem?.value" class="cc-text-center">
                <a
                  class="cc-clickable-link cc-hyper-link dx-theme-accent-as-text-color"
                >
                  {{ dashboardItem?.message }}
                </a>
              </div>
              <div
                *ngIf="!!dashboardItem?.html"
                class="message-text"
                [ngClass]="{ 'message-text-left': isQuickLinks }"
                [innerHTML]="dashboardItem?.html | ccSafeHtml"
              ></div>
            </div>
            <div
              *ngIf="!!dashboardItem?.childItem"
              class="child-item-container"
              (click)="togglePopoverVisibility(dashboardItem?.childItem)"
            >
              <div class="child-icon">
                <div
                  *ngIf="dashboardItem?.childItem.hasIcon"
                  class="dashboard-icon dx-theme-accent-as-background-color"
                  [ngClass]="{
                    'dashboard-icon-item-check': dashboardItem?.childItem.isOk
                  }"
                >
                  <i
                    [id]="'child-icon-' + elementId"
                    class="fas"
                    [ngClass]="{
                      'fa-check cc-lightgreen-icon':
                        dashboardItem?.childItem?.isOk,
                      'fa-info cc-white-icon': dashboardItem?.childItem?.isInfo,
                      'fa-exclamation': dashboardItem?.childItem?.isWarning,
                      'fa-exclamation-triangle':
                        dashboardItem?.childItem?.isHighAlert,
                      'cc-yellow-icon':
                        dashboardItem?.childItem?.isWarning ||
                        dashboardItem?.childItem?.isHighAlert
                    }"
                  ></i>
                </div>
              </div>
              <div
                *ngIf="!!dashboardItem?.childItem?.message"
                class="child-message"
              >
                <a
                  class="cc-clickable-link cc-hyper-link dx-theme-accent-as-text-color"
                >
                  {{ dashboardItem?.childItem?.message }}
                </a>
              </div>
            </div>
          </div>
        </dxi-item>
      </dx-box>
    </dxi-item>
  </dx-box>
</div>

<dx-popover
  [position]="'bottom'"
  [width]="isSmallScreen ? '75%' : '20%'"
  [height]="popoverHeight"
  [target]="'#icon-' + elementId"
  [showTitle]="false"
  [hideOnOutsideClick]="true"
  [(visible)]="popoverVisible"
>
  <dxo-animation>
    <dxo-show type="pop" [from]="{ scale: 0 }" [to]="{ scale: 1 }"></dxo-show>
    <dxo-hide type="fade" [from]="1" [to]="0"></dxo-hide>
  </dxo-animation>
  <div
    *dxTemplate="let data = model of 'content'"
    class="user-dashboard-item-popover-content"
  >
    <dx-box width="100%" height="100%" direction="col">
      <dxi-item baseSize="auto">
        <h4>
          <strong>{{ popoverDashboardItem.message }}</strong>
        </h4>
      </dxi-item>
      <dxi-item baseSize="auto"></dxi-item>
      <dxi-item [ratio]="1" *ngIf="popoverDashboardItem?.details?.length">
        <dx-data-grid
          width="100%"
          height="100%"
          [showBorders]="true"
          [showRowLines]="true"
          [rowAlternationEnabled]="true"
          [wordWrapEnabled]="true"
          [dataSource]="popoverDashboardItem?.details"
        >
          <dxo-header-filter [visible]="false"></dxo-header-filter>
          <dxo-filter-panel [visible]="false"></dxo-filter-panel>
          <dxi-column
            dataField="propertyAddress"
            caption="Property"
            cellTemplate="cellTemplate"
          ></dxi-column>
          <dxi-column
            [width]="100"
            dataField="value"
            alignment="center"
            [visible]="popoverDashboardItem?.valueVisible"
            [format]="popoverDashboardItem?.columnFormat"
            [caption]="popoverDashboardItem?.valueCaption"
            cellTemplate="valueCellTemplate"
          ></dxi-column>

          <div *dxTemplate="let col of 'cellTemplate'">
            <a
              class="cc-clickable-link cc-hyper-link dx-theme-accent-as-text-color"
              (click)="navigateFromGridRow(col.data)"
            >
              {{ col.value }}
            </a>
          </div>
          <div *dxTemplate="let col of 'valueCellTemplate'">
            <ng-container *ngIf="!col.data.isNumber">
              <div
                class="important-message-text"
                (click)="onImportantMessageClick(col.data)"
              >
                <a href="javascript:void(0)" class="cc-required-text">
                  <i
                    [ngClass]="iconExclamatory"
                    title="Account Balance Message"
                    class="cc-1-5x"
                  ></i>
                </a>
              </div>
            </ng-container>
            <ng-container
              *ngIf="
                col.data.isNumber &&
                popoverDashboardItem?.valueDataType === 'CURRENCY'
              "
            >
              {{ getFormattedValue(col.value) }}
            </ng-container>
            <ng-container
              *ngIf="
                col.data.isNumber &&
                popoverDashboardItem?.valueDataType !== 'CURRENCY'
              "
            >
              {{ col.value }}
            </ng-container>
          </div>
        </dx-data-grid>
      </dxi-item>
    </dx-box>
  </div>
</dx-popover>

<dx-load-panel
  [position]="{ of: '#portalDashboard' }"
  [(visible)]="loadingVisible"
  [showIndicator]="true"
  [showPane]="true"
  [shading]="true"
  [hideOnOutsideClick]="false"
></dx-load-panel>

<cc-message-box #messageBox></cc-message-box>
